<template>
  <Button
    type="button"
    variant="outline-primary"
    size="sm"
    class="tw:text-sm tw:max-w-full tw:w-full tw:truncate"
  >
    <slot />
  </Button>
</template>

<script setup>
import { Button } from '@/shadcn/components/ui/button/index.js'
</script>
